import { useCallback } from "react";
import { VolumeCardGroup } from "../../../../components";
import { useGetHiddenStoreItem } from "../../../../hooks/HiddenStore/hiddenstore.hooks";
import frame_1 from "../../images/frame_1.png";
import styles from "./style.module.scss";
import "./style.scss";

const ProductArea = ({ code }: { code: string }) => {
  const { data: items } = useGetHiddenStoreItem(
    { code: code },
    { enabled: !!code }
  );

  const renderVolumeCardGroup = useCallback((i: any) => {
    return (
      <VolumeCardGroup
        key={`${i.id}-${i.country_code}`}
        country={i.country_name_zh_TW}
        img={frame_1}
        data={i.item}
        flag={i.img}
        attention={i.info_zh_TW}
      />
    );
  }, []);

  return (
    <div className={styles.productArea} id="homeProductArea">
      <div className={styles.topCircle}></div>
      <div className={styles.contentContainer}>
        {items?.slice(0, 3).map((i: any) => renderVolumeCardGroup(i))}
      </div>
      <div className={styles.bottomCircle}></div>
    </div>
  );
};

export default ProductArea;
